import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { CANDIDATE_KEY } from './keys';
import { EnrollApi } from 'api';
import { SearchUserCandidatesQueryType } from 'types';

function useGetUserCandidates(query: SearchUserCandidatesQueryType) {
  return useAuthQuery(
    getQueryKeys(CANDIDATE_KEY).list({ ...query }),
    () => EnrollApi.getUserCandidates(query),
    {
      select: (data) => data.data,
      enabled: !!query.eventId,
    },
  );
}

export default useGetUserCandidates;
